'use strict';

/** Public store listing URLs. Keep empty until the listing is live. */
export const APPLE_APP_STORE_URL = '';

/** Future Play URL: https://play.google.com/store/apps/details?id=com.hotchillistudios.fuelcyclepro */
export const GOOGLE_PLAY_STORE_URL = '';

/** Closed-testing opt-in. The Google account on the phone must already be on the Play tester list. */
export const ANDROID_CLOSED_TEST_URL =
  'https://play.google.com/apps/testing/com.hotchillistudios.fuelcyclepro';

function toPublicStoreHref(raw) {
  const trimmed = String(raw ?? '').trim();
  return trimmed === '' ? null : trimmed;
}

/**
 * @param {{ apple?: string, play?: string }} [options]
 * @returns {{ apple: string|null, play: string|null }}
 */
export function getPublicStoreLinks(options = {}) {
  const appleRaw = options.apple !== undefined ? options.apple : APPLE_APP_STORE_URL;
  const playRaw = options.play !== undefined ? options.play : GOOGLE_PLAY_STORE_URL;
  return {
    apple: toPublicStoreHref(appleRaw),
    play: toPublicStoreHref(playRaw),
  };
}

export function hasPublicStoreLinks(links = getPublicStoreLinks()) {
  return links.apple != null || links.play != null;
}
